module.exports = __webpack_public_path__ + "img/targeted-support.0fadbab.jpg";